import React from 'react';
import {
  Button,
  DialogContentText
} from '@mui/material';
import BaseModal from '../common/BaseModal';
import { getSentence } from '../translations';

const SpeakerConfirmationDialog = ({
  open,
  oldSpeaker,
  newSpeaker,
  onConfirm,
  onCancel,
  isLoading = false
}) => {
  // Handle both close button and cancel button clicks
  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const actions = (
    <>
      <Button 
        onClick={(e) => {
          e.stopPropagation();
          handleClose();
        }}
        variant="outlined"
        disabled={isLoading}
        sx={{ 
          textTransform: 'none',
          minWidth: { xs: 'auto', sm: '100px' }
        }}
      >
        {getSentence(56)}
      </Button>
      <Button 
        onClick={(e) => {
          e.stopPropagation();
          if (onConfirm) onConfirm();
        }}
        variant="contained"
        disabled={isLoading}
        sx={{ 
          textTransform: 'none',
          minWidth: { xs: 'auto', sm: '100px' }
        }}
      >
        {isLoading ? 'Processing...' : getSentence(55)}
      </Button>
    </>
  );

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      title="Change Speaker"
      size="small"
      maxWidth="xs"
      actions={actions}
      aria-labelledby="speaker-change-dialog-title"
      aria-describedby="speaker-change-dialog-description"
    >
      <DialogContentText id="speaker-change-dialog-description">
        {getSentence(53)} <b>{oldSpeaker}</b> {getSentence(54)} <b>{newSpeaker}</b>?
      </DialogContentText>
    </BaseModal>
  );
};

SpeakerConfirmationDialog.displayName = 'SpeakerConfirmationDialog';

export default SpeakerConfirmationDialog; 